// Module
var code = `<div id="rubric-widget-points-element" data-cy="points-element" class="rb-widget rb-points"><div class="rb-avatar"><div class="rb-input" translate="rubric-widget-points_placeholder-pts"></div>&nbsp; <span translate="rubric-widget-points_item"></span>&nbsp; <span class="rb-label" translate="rubric-widget-points_ouy-of"></span></div></div>`;
// Exports
export default code;